import { CarrierSearch } from 'browser/components/atomic-elements/atoms/select/carrier-search/carrier-search'
import LabelFieldFactory from 'browser/components/atomic-elements/higher-order-components/label-field-factory'
const CarrierSearchField = LabelFieldFactory({ InputComponent: CarrierSearch })
export { CarrierSearchField }
